import * as React from 'react';
export function useInteractionTagContextValues_unstable(state) {
    const { appearance, disabled, handleTagDismiss, handleTagSelect, interactionTagPrimaryId, selected, selectedValues, shape, size, value } = state;
    return {
        interactionTag: React.useMemo(()=>({
                appearance,
                disabled,
                handleTagDismiss,
                handleTagSelect,
                interactionTagPrimaryId,
                selected,
                selectedValues,
                shape,
                size,
                value
            }), [
            appearance,
            disabled,
            handleTagDismiss,
            handleTagSelect,
            interactionTagPrimaryId,
            selected,
            selectedValues,
            shape,
            size,
            value
        ])
    };
}
